module.exports = __webpack_public_path__ + "img/16.eef3dd17.jpeg";